import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';

import styles from './Link.scss';

import LoggedOutMessages from './LoggedOutMessages';

export const Link = () => (
    <div className={styles.wrapper}>
        {LoggedOutMessages.map((msg, index) => (
            <div key={`body-${index}`} className={styles.messageText}>
                {msg}
            </div>
        ))}
        <div className={styles.linkTextWrapper}>
            <div className={styles.linkText}>
                <FormattedHTMLMessage
                    id="abt.sourcing.link.cta"
                    defaultMessage="Not a trade member? <a href='/trade/apply/'>Click here to apply!</a>"
                />
            </div>
        </div>
    </div>
);

Link.displayName = 'Link';

export default Link;
